/**
 * WebSocket URL aligned with dashboard API base (see services/api.js).
 * Relative /api builds must use the page origin with wss on HTTPS.
 */
export function resolveWebSocketUrl(path) {
  const pathNorm = path.startsWith('/') ? path : `/${path}`;
  const configured = process.env.REACT_APP_API_URL;

  if (configured && /^https?:\/\//i.test(configured)) {
    const origin = configured.replace(/\/api\/?$/, '');
    const host = origin.replace(/^https?:\/\//, '');
    const securePage =
      typeof window !== 'undefined' && window.location.protocol === 'https:';
    const wsProto = securePage || origin.startsWith('https') ? 'wss' : 'ws';
    return `${wsProto}://${host}${pathNorm}`;
  }

  if (typeof window !== 'undefined' && window.location?.host) {
    const wsProto = window.location.protocol === 'https:' ? 'wss' : 'ws';
    return `${wsProto}://${window.location.host}${pathNorm}`;
  }

  return `ws://localhost:8000${pathNorm}`;
}
